import React, { FC, useState, Fragment } from 'react'
import { IonPage, IonContent, useIonViewWillEnter, IonSpinner } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { orderMobx, storeMobx, cartMobx } from 'restaurant'
import { BagIcon, CountDown } from 'components'
import i18n from 'i18next'
import { ddayjs, format } from '@dt/fe-utils'
import payMobx from '@mobx/pay/pay.mobx'
import './index.scss'

interface IProps extends RouteComponentProps {
}

let isSend = false // 是否发送短信
let initCnt = 0
let st: any = null

const payIcon = {
  cn: 'icon-guoneizhifuchenggong2x',
  us: 'icon-fukuanlu',
  de: 'icon-deyuchenggong'
}

const Bill: FC<IProps> = ({ match }) => {
  const [isCheckPay, setIsCheckPay] = useState(true)
  const viewOrder = orderMobx.viewOrder
  const viewDetailList = orderMobx.viewDetailList

  const getDelayOrder = (orderNo: string) => {
    orderMobx.init(orderNo, { isNoToken: true }).then(() => {
      initCnt += 1
      if (orderMobx.viewOrder.status === 'Paying' || orderMobx.viewOrder.status === 'Pending') {
        if (initCnt < 4) {
          st = setTimeout(() => getDelayOrder(orderNo), 300)
        } else {
          setIsCheckPay(false)
        }
      } else {
        setIsCheckPay(false)
        if (orderMobx.viewOrder.status === 'Success') {
          cartMobx.clearPart({ remark: '', person: 1, startTime: null, ordersId: '', managerDiscount: null })
        }
      }
    }).catch((err: any) => {
      console.log(err)
    })
  }

  useIonViewWillEnter(() => {
    const orderNo = location.pathname.split('/')[2]
    isSend = false
    initCnt = 0
    getDelayOrder(orderNo)
  })

  return (
    <IonPage className='pay-bill-page'>
      <IonContent className='pay-bill-content'>
        <div className='bill-top'>
          <div className='img-box' style={{ backgroundImage: `url(${storeMobx.brand.logo || Config.defaultImg.store})` }}></div>
          <h3>{storeMobx.info.storeName}</h3>
          <p>
            <span>{i18n.t('bill.hi')}</span>
            <span>{i18n.t('bill.billTop')}</span>
          </p>
          <div>{i18n.t('bill.yourBill')}</div>
        </div>
        <div className='bill-detail'>
          {
            isCheckPay ? (
              <div className='result-checking'>
                <IonSpinner name='dots' />
              </div>
            ) : viewOrder.status === 'Success' || viewOrder.status === 'Timeout' || viewOrder.sourceType === 'onlineMobileSpecial' ? (
              <div className='result-detail'>
                <h2>{`#${viewOrder.nono === '0' ? '' : viewOrder.nono}`}</h2>
                <h6>{i18n.t(`menu.${viewOrder.eatType}`)}</h6>
                {
                  viewOrder.sourceType === 'onlineMobileSpecial' ? (
                    <p>{viewOrder.status === 'Timeout' ? i18n.t('result.specialTimeOut') : viewOrder.status === 'Success' ? i18n.t('result.specialSuccess') : i18n.t('result.specialPending')}</p>
                  ) : (
                    <p>{viewOrder.status === 'Timeout' ? i18n.t('result.timeOut') : i18n.t(`result.${viewOrder.eatType}Tips`)}</p>
                  )
                }
              </div>
            ) : (
              <div className='pay-error'>
                <i className='iconfont icon-warning-circle' />
                {viewOrder.payMode ? (
                  <span>{i18n.t('result.payErrorTips')}</span>
                ) : orderMobx.viewOrder.addTime && ((ddayjs(orderMobx.viewOrder.addTime).valueOf() + 15 * 60 * 1000) < Date.now()) ? (
                  <span>
                    {i18n.t('result.timeOut')}<br />
                  </span>
                ) : (
                  <CountDown
                    orderAddTime={ddayjs(orderMobx.viewOrder.addTime).valueOf()}
                    endTips={i18n.t('result.timeOut')}
                    downTips={(time: string) => i18n.t('result.payError', { time })}
                  />
                )}
              </div>
            )
          }
          <div className='iconfont-wrap' style={{ display: viewOrder.status === 'Success' ? 'block' : 'none' }}>
            <i className={`iconfont ${payIcon[bo]}`}></i>
          </div>
          <div className='circle'></div>
          <div className='dashed'></div>
          <div className='address-wrap space-between'>
            <div className='address-left'>
              <img src={storeMobx.brand.logo || Config.defaultImg.store} />
              <div className='name'>
                <p>{viewOrder.store?.storeName}</p>
                <p>{viewOrder.store?.address}</p>
              </div>
            </div>
          </div>
          {
            viewOrder.remark ? (
              <>
                <div className='dashed'></div>
                <div className='remark'>
                  {i18n.t('common.note')}: {viewOrder.remark}
                </div>
              </>
            ) : null
          }
          <div className='dashed'></div>
          <div className='product-list'>
            {
              viewDetailList.map((item: any) => {
                return (
                  <>
                    <div className='product-item-wrap'>
                      <div className='product-item' key={item.productNo}>
                        <div className='count'>x{item.cnt}</div>
                        <div className='name'>
                          <p>{item.name} {!!item.isTogo && <BagIcon size='small' />}</p>
                          {!!item.optionHtml && <p dangerouslySetInnerHTML={{ __html: item.optionHtml }} />}
                          {!!item.remark && (<p className='note'>{i18n.t('common.note')}: {item.remark}</p>)}
                        </div>
                        <div className='price'>{format.toPrice(item.totalPrice)}</div>
                      </div>
                      {
                        item.offItems.map((v: any, index: number) => {
                          return (
                            <div className='discount-item space-between' key={index}>
                              <span className='name'>{v.offType === 'memberPrice' ? i18n.t('result.member_price') : v.offTip}</span>
                              <span className='price'>- {format.toPrice(v.off)}</span>
                            </div>
                          )
                        })
                      }
                    </div>
                  </>
                )
              })
            }
          </div>
          <div className='hide-detail'>
            <div className='dashed'></div>
            {/* {
            viewOrder.discountItemPrice > 0 ? (
              <div className='detail-item space-between'>
                <span className='title'>{i18n.t('result.productDiscount')}</span>
                <span className='content'>-{format.toPrice(viewOrder.discountItemPrice || 0)}</span>
              </div>
            ) : null
          } */}
            {
              viewOrder.offItems.map((offItem, index) => (
                <div key={index} className='detail-item space-between'>
                  <span className='title'>{offItem.offTip}</span>
                  <span className='content'>-{format.toPrice(offItem.off)}</span>
                </div>
              ))
            }
            {
              viewOrder.discountIntegralMoneyPrice > 0 ? (
                <div className='detail-item space-between'>
                  <span className='title'>{i18n.t('result.integralMoney')}</span>
                  <span className='content'>
                    -{format.toPrice(orderMobx.viewOrder.discountIntegralMoneyPrice)}
                  </span>
                </div>
              ) : null
            }
            {
              viewOrder.orderPlanOffItem ? (
                <div className='detail-item space-between'>
                  <span className='title'>
                    {orderMobx.viewOrder.orderPlanOffItem.tagId ? orderMobx.viewOrder.orderPlanOffItem.offTip : i18n.t('result.managerDiscount')}
                  </span>
                  <span className='content'>
                    -{format.toPrice(orderMobx.viewOrder.orderPlanOffItem.off)}
                  </span>
                </div>
              ) : null
            }
            {
              bo === 'us' ? (
                <div className='detail-item space-between'>
                  <span className='title'>{i18n.t('result.subTotal')}</span>
                  <span className='content'>{format.toPrice(viewOrder.itemTotalPrice || 0)}</span>
                </div>
              ) : null
            }
            {
              viewOrder.discountFloorPrice > 0 ? (
                <div className='detail-item space-between'>
                  <span className='title'>{i18n.t('result.floor')}</span>
                  <span className='content'>
                    -{format.toPrice(viewOrder.discountFloorPrice)}
                  </span>
                </div>
              ) : null
            }
            {
              viewOrder.serviceCharge > 0 ? (
                <div className='detail-item space-between'>
                  <span className='title'>{viewOrder.serviceChargeGratuityName}</span>
                  <span className='content'>{format.toPrice(viewOrder.serviceCharge || 0)}</span>
                </div>
              ) : null
            }
            {
              viewOrder.tax > 0 || bo === 'us' ? (
                <div className='detail-item space-between'>
                  <span className='title'>{i18n.t('result.tax')}</span>
                  <span className='content'>{format.toPrice(viewOrder.tax || 0)}</span>
                </div>
              ) : null
            }
            {
              viewOrder.showTax > 0 && bo === 'us' ? (
                <div className='detail-item space-between'>
                  <div className='title'>{i18n.t('cart.haveTax')}</div>
                  <div className='content'>{format.toPrice(viewOrder.showTax)}</div>
                </div>
              ) : null
            }
            <div className='detail-item space-between'>
              <span className='title'>{i18n.t('result.total')}</span>
              <span className='content font-weight'>{format.toPrice(viewOrder.totalPriceExcludeTip || 0)}</span>
            </div>
            <div className='dashed'></div>
            {
              viewOrder.tip > 0 ? (
                <div className='detail-item space-between'>
                  <span className='title'>{i18n.t('result.tip')}</span>
                  <span className='content'>{format.toPrice(viewOrder.tip)}</span>
                </div>
              ) : null
            }
            <div className='detail-item space-between'>
              <span className='title'>{i18n.t('result.alltotal')}</span>
              <span className='content font-weight'>{format.toPrice(Number(viewOrder.totalPrice))}</span>
            </div>
            <div className='dashed'></div>
            <div className='detail-item space-between'>
              <span className='title'>{i18n.t('result.partySize')}</span>
              <span className='content'>{viewOrder.person}</span>
            </div>
            <div className='detail-item space-between'>
              <span className='title'>{i18n.t(`newCart.${viewOrder.eatType}time`)}</span>
              <span className='content'>{viewOrder.addTime === viewOrder.startTime ? i18n.t('cart.asap') : format.toDateTime(viewOrder.startTime)}</span>
            </div>
            {viewOrder.paymentList?.length ? (<div className='dashed'></div>) : null}
            {
            viewOrder.paymentList?.map((pay: any) => {
              const { name, cardNo, amountPaid } = payMobx.getPaymentDisplay(pay)
              return (
                <Fragment key={pay.paymentId}>
                  {
                    viewOrder.paymentList.length > 1 ? (<div className='detail-item space-between'><span className='title'>{i18n.t('result.payment')}</span></div>) : null
                  }
                  <div className='detail-item space-between'>
                    <span className='title'>{viewOrder.paymentList.length === 1 ? i18n.t('result.payment') : name}</span>
                    <span className='content'>{viewOrder.paymentList.length === 1 ? name : format.toPrice(amountPaid)}</span>
                  </div>
                  <div className='detail-item space-between' style={{ display: !cardNo ? 'none' : 'flex' }}>
                    <span className='title'>{i18n.t('result.cardNumber')}</span>
                    <span className='content'>**** {cardNo?.substring(cardNo.length - 4, cardNo.length)}</span>
                  </div>
                </Fragment>
              )
            })
            }
            <div className='dashed'></div>
            <div className='detail-item space-between light'>
              <span className='title'>{i18n.t('result.orderTime')}</span>
              <span className='content'>{format.toDateTime(viewOrder.addTime)}</span>
            </div>
            {/* <div className='detail-item space-between light'>
                <span className='title'>Order Number :</span>
                <span className='content'>2345436787672345</span>
              </div> */}
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(Bill)
